import type { AppState } from '@store/types'
import { put, select } from 'redux-saga/effects'

import { artBoardActions } from '../actions'
import type { ArtBoardMode } from '../types'

// The legacy threadsPanelShow/Hide pair is untyped JS: one action type, the
// direction is the payload.
interface ThreadsPanelShownAction {
  type: string
  payload: boolean
}

// The comment tool opens the panel, so closing the panel cancels the comment:
// the crosshair goes with the mode. Other modes are none of the panel's
// business. The tool's own second click does the same in ProjectToolbar.
export function* leaveCommentModeOnPanelClose({
  payload,
}: ThreadsPanelShownAction) {
  if (payload) {
    return
  }

  const mode: ArtBoardMode = yield select(
    ({ artboard }: AppState) => artboard.mode
  )

  if (mode !== 'new_thread') {
    return
  }

  yield put(artBoardActions.changeMode('edit'))
}
